import {GameStrategy} from './strategies/base/GameStrategy';
import {ClueGiverStrategy} from './strategies/similo/ClueGiverStrategy';
import {GuesserStarategy} from './strategies/similo/GuesserStarategy';
import {DetectiveClubPlayerStrategy} from './strategies/detective_club/DetectiveClubPlayerStarategy';
import {LoggedAfterGameStartedPlayerStrategy} from './strategies/missed/LoggedAfterGameStartedPlayerStrategy';

export class GamesStrategiesController
{
    static commandsStrategies: GameStrategy[] = [
        new LoggedAfterGameStartedPlayerStrategy(),
        //Similo
        new ClueGiverStrategy(),
        new GuesserStarategy(),
        //DetectiveClub
        new DetectiveClubPlayerStrategy()
    ];

    static getStrategy(gameState: any): GameStrategy | undefined {
        return GamesStrategiesController.commandsStrategies.find(strategy => strategy.isApplicable(gameState));
    }

    static disable(): void {
        GamesStrategiesController.commandsStrategies.forEach(strategy => strategy.disable());
    }
}
